export const SOCKET_NOTIFICATION_RECEIVED = 'notification:received';
export const COUNT_NOTIFICATIONS = 'siteNotifications/COUNT_NOTIFICATIONS';
export const GET_NOTIFICATIONS_LIST = 'siteNotifications/GET_NOTIFICATIONS_LIST';
export const READ_NOTIFICATIONS = 'siteNotifications/READ_NOTIFICATIONS';

export function countNotifications() {
    return {
        type: COUNT_NOTIFICATIONS,
        httpRequest: {
            method: 'get',
            path: '/siteNotifications/count',
        },
    };
}

export function getNotificationsList() {
    return {
        type: GET_NOTIFICATIONS_LIST,
        httpRequest: {
            method: 'get',
            path: '/siteNotifications',
        },
    };
}

export function readNotifications(ids = []) {
    return {
        type: READ_NOTIFICATIONS,
        httpRequest: {
            method: 'post',
            path: '/siteNotifications',
            data: {
                ids,
            },
        },
        ids,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/siteNotification/siteNotificationActions.js